import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { CoveringsAPI } from '../../../services/external/APIs/coverings/Coverings.api';

export const useCoverManagement = (reloadingCovers: () => void) => {
    const [isLoadingManagement, setIsLoadingManagement] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const approveCover = (id: number, comments: string, onClose: () => void) => {
        const toastId = toast.loading('Aprobando cubrimientos...');
        setIsLoadingManagement(true);
        CoveringsAPI.approveCover(id, comments)
            .then(() => {
                setErrorMessage('');
                toast.update(toastId, {
                    render: 'Se aprobó el cubrimiento exitosamente',
                    type: 'success',
                    isLoading: false,
                    autoClose: 5000,
                    position: toast.POSITION.BOTTOM_RIGHT,
                    closeOnClick: true,
                    closeButton: true,
                });
                reloadingCovers();
                onClose();
            })
            .catch((error) => {
                let msgError = '';
                if (error.response && typeof error.response.data == 'string') {
                    setErrorMessage(error.response.data);
                    msgError = error.response.data;
                } else {
                    setErrorMessage('Ocurrió un error al aprobar el cubrimiento');
                    msgError = 'Ocurrió un error al aprobar el cubrimiento';
                }
                toast.update(toastId, {
                    render: msgError,
                    type: 'error',
                    isLoading: false,
                    autoClose: 5000,
                    position: toast.POSITION.BOTTOM_RIGHT,
                    closeOnClick: true,
                    closeButton: true,
                });
            })
            .finally(() => {
                setIsLoadingManagement(false);
            });
    };

    const rejectCover = (id: number, comments: string, onClose: () => void) => {
        const toastId = toast.loading('Rechazando cubrimientos...');
        setIsLoadingManagement(true);
        CoveringsAPI.rejectCoverBy(id, comments)
            .then(() => {
                setErrorMessage('');
                toast.update(toastId, {
                    render: 'Se rechazó el cubrimiento exitosamente',
                    type: 'success',
                    isLoading: false,
                    autoClose: 5000,
                    position: toast.POSITION.BOTTOM_RIGHT,
                    closeOnClick: true,
                    closeButton: true,
                });
                reloadingCovers();
                onClose();
            })
            .catch((error) => {
                let msgError = '';
                if (error.response && typeof error.response.data == 'string') {
                    setErrorMessage(error.response.data);
                    msgError = error.response.data;
                } else {
                    setErrorMessage('Ocurrió un error al rechazar el cubrimiento');
                    msgError = 'Ocurrió un error al rechazar el cubrimiento';
                }
                toast.update(toastId, {
                    render: msgError,
                    type: 'error',
                    isLoading: false,
                    autoClose: 5000,
                    position: toast.POSITION.BOTTOM_RIGHT,
                    closeOnClick: true,
                    closeButton: true,
                });
            })
            .finally(() => {
                setIsLoadingManagement(false);
            });
    };

    return {
        rejectCover,
        approveCover,
        errorMessage,
        isLoadingManagement,
        setErrorMessage,
    };
};
